import { businessKey } from 'queryKeys';

export const ANNOTATIONS = 'annotations';
const annotationsQuery = businessKey.query(ANNOTATIONS);

export const grid = annotationsQuery.grid();

export const mutations = annotationsQuery.mutations();

export const create = mutations.create();
export const update = mutations.update();
export const remove = mutations.delete();
